<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.institutions',1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="row">

                        <b-container>

                            <b-row>
                                <b-col col sm="8">
                                    <div class="list-group">
                                        <b-row>
                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.nomPartenaire') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ nom }} </p>
                                                </span>
                                                </div>
                                            </b-col>

                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.email') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ email }} </p>
                                                </span>
                                                </div>
                                            </b-col>

                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.phoneNumber') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ telephone }} </p>
                                                </span>
                                                </div>
                                            </b-col>

                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.institution') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                                <b-col col sm="4">
                                    <b-row class="justify-content-sm-center">
                                        <b-button variant="primary" @click="updateComptable">
                                            {{ $t('message.edit') }}
                                        </b-button>

                                        <b-button variant="danger" v-b-modal.delete-modal>
                                            {{ $t('message.delete') }}
                                        </b-button>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $t('message.categoriePrestation')"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteComptable">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";

    export default {
        name: "Accountant",
        computed: {
            ...mapGetters(["comptable",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            mComptable: function() {
                return this.comptable;
            },

            nom:function(){
                if (!_.isUndefined(this.comptable.user) && !_.isNull(this.comptable.user)) {
                    let user = this.comptable.user;
                    let prenom = (user.prenom == null) ? '' : user.prenom;
                    return (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                }
                return '';
            },
            etablissement:function(){
                return this.comptable.etablissements.name;
            },

            email:function(){
                if (!_.isNull(this.comptable.user)){
                    return this.comptable.user.email;
                }
                return '';
            },

            telephone:function(){
                return this.comptable.user.telephone;
            }
        },

        data() {
            return {
                comptable_id: this.$route.params.accountant,
            }
        },

        methods: {
            getComptable() {
                let args = {
                    comptable: this.comptable_id,
                };
                this.$store.dispatch("getComptable", {args});
            },

            onPrestationClick(params) {
                this.$router.push({ name: 'prestation', params: { prestation: params.row.slug } });

            },
            deleteComptable() {
                let args = {
                    comptable: this.comptable_id,
                };

                let successMessage = this.$i18n.t('message.comptableDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteComptable', {args, successMessage, errorMessages})
            },
            updateComptable:function () {
                this.$router.push({ name: 'edit-accountant', params: { accountant: this.comptable_id } });

            }
        },
        mounted() {
            this.getComptable();
        }
    }
</script>

<style scoped>

</style>